// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__1wZED","title":"Header_title__1Z0uY","moreBtn":"Header_moreBtn__D82UJ","focus":"Header_focus__YRkyj"};